module.exports = __webpack_public_path__ + "img/facebook.8c89ef8a.png";